import { createContext, useEffect, useState } from "react";
import API from "../api/axios";

export const StoryContext = createContext();

export const StoryProvider = ({ children }) => {

  // STORIES
  const [stories, setStories] = useState([]);

  // BOOKMARKS
  const [bookmarks, setBookmarks] = useState([]);

  // PAGINATION
  const [totalPages, setTotalPages] = useState(1);

  // GET STORIES
  const getStories = async (page = 1) => {

    try {

      const res = await API.get(
        `/stories?page=${page}&limit=5`
      );

      console.log("API RESPONSE =>", res.data);

      // SAFE DATA HANDLE
      if (Array.isArray(res.data)) {

        setStories(res.data);

      } else if (Array.isArray(res.data.stories)) {

        setStories(res.data.stories);

        setTotalPages(res.data.totalPages || 1);

      } else {

        setStories([]);
      }

    } catch (error) {

      console.log("GET STORIES ERROR =>", error);

      setStories([]);
    }
  };

  // GET BOOKMARKS
  const getBookmarks = async () => {

    try {

      const res = await API.get(
        "/stories/bookmarks"
      );

      setBookmarks(res.data.bookmarks || res.data || []);

    } catch (error) {

      console.log(error);
    }
  };

  // TOGGLE BOOKMARK
  const toggleBookmark = async (id) => {

    try {

      const res = await API.post(
        `/stories/${id}/bookmark`
      );

      setBookmarks(res.data.bookmarks || []);

    } catch (error) {

      console.log(error);
    }
  };

  // INITIAL LOAD
  useEffect(() => {

    getStories();

  }, []);

  return (
    <StoryContext.Provider
      value={{
        stories,
        bookmarks,
        totalPages,
        getStories,
        getBookmarks,
        toggleBookmark,
      }}
    >
      {children}
    </StoryContext.Provider>
  );
};